import React from 'react';
import { Text } from '@billda/design-system';

interface MetricDisplayProps {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
  /** Text colour class (semantic token, e.g. text-content-accent). */
  color?: string;
}

export const MetricDisplay: React.FC<MetricDisplayProps> = ({
  label,
  value,
  icon,
  color,
}) => {
  return (
    <div className="flex flex-col items-start gap-1">
      <div className="flex items-center gap-1">
        {icon}
        <Text variant="overline" color="secondary">
          {label}
        </Text>
      </div>
      <Text
        variant="h6"
        className={
          color
            ? `font-semibold leading-[1.2] ${color}`
            : 'font-semibold leading-[1.2]'
        }
      >
        {value}
      </Text>
    </div>
  );
};
